import { BaseService } from './base-service';
import {
	CreateWorkerRequestDTO,
	GetWorkerRequestDTO,
	GetWorkerResponseDTO,
	UpdateWorkerRequestDTO,
	CreateWorkerResponseDTO,
	UpdateWorkerResponseDTO,
	GetListWorkerRequestDTO,
	GetListWorkerResponseDTO,
	DestroyWorkerRequestDTO,
	DestroyWorkerResponseDTO
} from '@/core/dto';

export class WorkerService extends BaseService<any> {
	private static instance: WorkerService;

	constructor(public readonly basePath: string = '/worker') {
		super();
	}

	public static getInstance(): WorkerService {
		if (!WorkerService.instance) {
			WorkerService.instance = new WorkerService();
		}
		return WorkerService.instance;
	}

	public async index(params: GetListWorkerRequestDTO): Promise<GetListWorkerResponseDTO> {
		const url = this.basePath + '/';
		const { data } = await this.getInstance().get(url, { params });
		return data;
	}

	public async show(params: GetWorkerRequestDTO): Promise<GetWorkerResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().get(url, { params });
		return data;
	}

	public async create(params: CreateWorkerRequestDTO): Promise<CreateWorkerResponseDTO> {
		const url = this.basePath;
		const { data } = await this.getInstance().post(url, params);
		return data;
	}

	public async update(params: UpdateWorkerRequestDTO): Promise<UpdateWorkerResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().put(url, params);
		return data;
	}

	public async destroy(params: DestroyWorkerRequestDTO): Promise<DestroyWorkerResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().delete(url);
		return data;
	}
}
